namespace GeniuzPOS.LogManage {
    export class LogJsonColumns {
        static columnsKey = 'LogManage.LogJson';
    }
}
